/* eslint-disable react/require-default-props */
import React from 'react';
import { FormControl, FormLabel } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { useStoreActions, useStoreState } from '../../../models/hooks';
import { MultiSelect } from '../../administration/positionManagement/recruiterWatchAndFollow/positions/MultiSelect';

interface PositionFilterProps {
  values: string[];
  onChange: (positions: string[], isAllSelcted: boolean) => void;
  isDisabled?: boolean;
  isSelectAll?: boolean;
}

export const PositionFilter = React.memo(function PositionFilter({
  values,
  onChange,
  isSelectAll,
  isDisabled,
}: PositionFilterProps) {
  const { t } = useTranslation('candidateSearch');

  const accountId = useStoreState((s) => s.app.user?.account);

  const { fetchJobs } = useStoreActions((state) => state.moniterByRecruiters);
  const [isLoading, setIsLoading] = React.useState(false);
  const [jobs, setJobs] = React.useState<string[]>([]);

  React.useEffect(() => {
    /* istanbul ignore else */
    if (accountId) {
      setIsLoading(true);
      fetchJobs({ accountId })
        .then((res) => {
          const positions = res ?? /* istanbul ignore next */ {};
          const openedPositions = Object.keys(positions).filter((key) => positions[key] === 'open');
          setJobs(openedPositions);
        })
        .catch(console.error)
        .finally(() => {
          setIsLoading(false);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId]);

  const options = React.useMemo(() => {
    return jobs?.map(/* istanbul ignore next */ (job) => ({ value: job, label: job }));
  }, [jobs]);

  return (
    <FormControl display="flex" flexDirection="column">
      <FormLabel htmlFor="label" mb="0" fontSize="sm">
        {t('filters.position.label')}
      </FormLabel>
      <MultiSelect
        options={options}
        selectedValues={values ?? /* istanbul ignore next */ []}
        onChange={onChange}
        selectAll={isSelectAll ?? false}
        label={t('filters.position.label')}
        allSelectText={t('filters.position.allSelected')}
        placeholder={t('filters.position.searchPlaceholder')}
        isLoading={isLoading}
        disabled={isLoading || isDisabled}
        height={400}
        itemHeight={40}
      />
    </FormControl>
  );
});
